module.exports = __webpack_public_path__ + "static/media/newsPoint05.eff055f1.jpeg";